const PRE = 'PERFIL_';


export const SALVAR = PRE + 'SALVAR';
export const BUSCAR = PRE + 'LISTAR';






// WEBPACK FOOTER //
// ./src/routes/private/PerfilUsuario/actionTypes.js